export default "__VITE_ASSET__BOQ07Wqy__"